import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TopbarNavLink} from './topbar-nav.constants';

// Where the top bar's destinations go on a phone. They collapse behind the
// hamburger below lg; a tablet gets them as a dropdown instead, and only this
// narrow case gets a sheet. Opened through the shared openModal helper like
// every other modal, which is what puts it at the bottom of the screen.
@Component({
    selector: 'app-topbar-nav-modal',
    templateUrl: './topbar-nav-modal.component.html',
})
export class TopbarNavModalComponent {
    // Set only for members who can still upgrade; null hides the button. A
    // link rather than the user, so this component never needs the model.
    readonly upgradeLink: string | null;
    readonly links: TopbarNavLink[];

    constructor(
        private ref: DynamicDialogRef,
        config: DynamicDialogConfig
    ) {
        this.upgradeLink = config.data?.upgradeLink ?? null;
        this.links = config.data.links;
    }

    close(): void {
        this.ref.close();
    }
}
